import { useTranslation } from 'react-i18next';
import {
    Banner,
    BannerDescription,
    BannerEyebrow,
    BannerImage,
    BannerImageContainer,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    BoundedContent,
    Button,
    FluidImage,
    Link,
} from '@vp/swan';
import { sanitiseLocale } from '../../../../i18n/config';
import { logomakerCtaPathByLocale } from '../../../../utils/urls';

const FeatureBannerMoreForFree = () => {
    const { t, i18n } = useTranslation();
    const locale = sanitiseLocale(i18n.language);

    return (
        <BoundedContent as="section" id="more-for-free">
            <Banner backgroundColor="standard">
                <BannerTextContainer>
                    <BannerText>
                        <BannerEyebrow>
                            {t(
                                'Logomaker GenAi Landing Page > Feature Banner More For Free > Eyebrow.value',
                            )}
                        </BannerEyebrow>
                        <BannerTitle as="h2" fontSkin="title-section">
                            {t(
                                'Logomaker GenAi Landing Page > Feature Banner More For Free > Title.value',
                            )}
                        </BannerTitle>
                        <BannerDescription as="p">
                            {t(
                                'Logomaker GenAi Landing Page > Feature Banner More For Free > Description.value',
                            )}
                        </BannerDescription>
                        <BannerLinks display={{ xs: 'none', sm: 'flex' }}>
                            <Button
                                skin="primary"
                                render={(props) => (
                                    // TODO: Add tracking
                                    <Link
                                        to={logomakerCtaPathByLocale(locale)}
                                        className={props.className}
                                    >
                                        {props.children}
                                    </Link>
                                )}
                            >
                                {t(
                                    'Logomaker GenAi Landing Page > Feature Banner More For Free > CTA Text.value',
                                )}
                            </Button>
                        </BannerLinks>
                    </BannerText>
                </BannerTextContainer>
                <BannerImageContainer>
                    <BannerImage>
                        <FluidImage
                            src={t(
                                'Logomaker GenAi Landing Page > Feature Banner More For Free > Image.src',
                            )}
                            alt={t(
                                'Logomaker GenAi Landing Page > Feature Banner More For Free > Image > Alt Text.value',
                            )}
                        />
                    </BannerImage>
                </BannerImageContainer>
            </Banner>
        </BoundedContent>
    );
};

export default FeatureBannerMoreForFree;
